export interface Rect {
  x: number;
  y: number;
  width: number;
  height: number;
}

/**
 * アスペクト比を維持したまま内容物を枠内に最大サイズで収める配置を計算する
 */
export function fitRect(
  contentWidth: number,
  contentHeight: number,
  frameWidth: number,
  frameHeight: number
): Rect {
  const contentAspect = contentWidth / contentHeight;
  const frameAspect = frameWidth / frameHeight;

  if (contentAspect > frameAspect) {
    const height = frameWidth / contentAspect;
    return { x: 0, y: (frameHeight - height) / 2, width: frameWidth, height };
  }

  const width = frameHeight * contentAspect;
  return { x: (frameWidth - width) / 2, y: 0, width, height: frameHeight };
}

/**
 * 16進カラーを "r, g, b" 形式に変換する。不正な値は黒にフォールバックする。
 */
export function hexToRgb(hex: string): string {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) return '0, 0, 0';
  return `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}`;
}
